import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Image from 'components/common/Image'
import Link from 'components/common/Link/Link'
import Rating, { BazaarVoiceRating } from 'components/common/Rating'
import CompatibilityLabel from 'components/common/CompatibilityLabel'
import SpecialOrder from 'components/common/SpecialOrder'
import { expandBazaarVoiceReviewTabAndScrollDown } from 'helpers/custom-events'
import withSetBazaarVoiceInlineRatings from 'components/common/hoc/withBazaarVoiceInlineRatings/withSetBazaarVoiceInlineRatings'
import ProductFlag from 'components/common/ProductFlag/ProductFlag'
import {
  OE_TOOLTIP_MESSAGE,
  OE_FLAG_TYPE,
  OE_FLAG_NAME,
  EVS_FLAG_TYPE,
  EVS_FLAG_NAME,
  EVS_TOOLTIP_MESSAGE,
  EVS_FLAG_ICON_NAME,
  EVC_FLAG_TYPE,
  EVC_FLAG_NAME,
  EVC_TOOLTIP_MESSAGE,
  EVC_FLAG_ICON_NAME
} from 'components/common/ProductFlag/constans'

const TireHeader = ({
  brandLogo,
  brandDetailsUrl,
  brandName,
  isSpecialOrder,
  name,
  frontTire: {
    tireSize,
    bvId,
    mspn = bvId,
    altMspn,
    compatibilityStatus: { compatibilityType } = {}
  },
  rearTire: {
    tireSize: rtireSize,
    bvId: rbvID,
    mspn: rmspn = rbvID,
    altMspn: raltMspn,
    compatibilityStatus: {
      compatibilityType: rearCompatibilityType
    } = {}
  },
  vehicleName,
  oeFlag,
  isEvItem,
  itemEVType
}) =>
  <Wrapper>
    <Link to={ brandDetailsUrl }>
      <Image data-at-sku-brand-img src={ `${brandLogo}?$BOT-TireDetail-Brand-Desktop-w132$` } alt={ brandName } />
    </Link>
    <Title data-at-sku-title>
      { name }
      <br />
      { rtireSize ? 'FRONT: ' : '' }{tireSize}
      {rtireSize && <br />}
      { rtireSize && 'REAR: '}{rtireSize}
    </Title>
    <CompatibilityLabel
      status={ rearCompatibilityType || compatibilityType }
      vehicle={ vehicleName } />
    <Size data-at-tirecontrol-size altMspn={ altMspn } mspn={ mspn }>
      { rtireSize ? 'FRONT: ' : '' }{tireSize}
      { mspn && <div data-at-tirecontrol-mspn>MSPN: { mspn }</div>}
    </Size>
    {
      rtireSize &&
        <Size data-at-tirecontrol-size altMspn={ raltMspn } mspn={ rmspn }>
          REAR: { rtireSize }
          { rmspn && <div data-at-tirecontrol-mspn>MSPN: { rmspn }</div>}
        </Size>
    }
    {
      isSpecialOrder && <SpecialOrder morePadding />
    }
    {
      bvId ?
        <BazaarVoiceRating
          bvId={ bvId }
          reviewName={ name }
          anchor
          prevent
          handler={ expandBazaarVoiceReviewTabAndScrollDown } /> :
        <Rating noReviews />
    }
    { (oeFlag || isEvItem) &&
      <ProductFlagWrapper>
        { oeFlag &&
          <ProductFlag
            name={ OE_FLAG_NAME }
            flagType={ OE_FLAG_TYPE }
            tooltipMessage={ OE_TOOLTIP_MESSAGE }
            asset="icon-info-blue-regular"
            alternative="icon-info-blue-solid" />
        }
        { (isEvItem && itemEVType === EVS_FLAG_TYPE) &&
          <ProductFlag
            name={ EVS_FLAG_NAME }
            flagType={ EVS_FLAG_ICON_NAME }
            tooltipMessage={ EVS_TOOLTIP_MESSAGE }
            asset="icon-info-blue-regular"
            alternative="icon-info-blue-solid" />
        }
        { (isEvItem && itemEVType === EVC_FLAG_TYPE) &&
          <ProductFlag
            name={ EVC_FLAG_NAME }
            flagType={ EVC_FLAG_ICON_NAME }
            tooltipMessage={ EVC_TOOLTIP_MESSAGE }
            asset="icon-info-blue-regular"
            alternative="icon-info-blue-solid" />
        }
      </ProductFlagWrapper>
    }
  </Wrapper>

export default withSetBazaarVoiceInlineRatings(TireHeader)

TireHeader.propTypes = {
  brandDetailsUrl: PropTypes.string,
  brandLogo: PropTypes.string,
  brandName: PropTypes.string,
  frontTire: PropTypes.shape(),
  isEvItem: PropTypes.bool,
  isSpecialOrder: PropTypes.bool,
  itemEVType: PropTypes.string,
  name: PropTypes.string,
  oeFlag: PropTypes.bool,
  rearTire: PropTypes.shape(),
  vehicleName: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  padding: 40px 0 23px;
  color: ${Theme.colors.black_new};
  border-bottom: 1px solid ${Theme.colors.light_grey};
  ${Mixin.font.GothamBook(14)}
  ${Media.mobile`
    padding: 31px 16px 22px;
    border-bottom: none;
  `}
`

const Title = styled.h1`
  margin: 15px 0 20px;
  line-height: 2rem;
  ${Mixin.font.GothamBold(24)}
`

const ProductFlagWrapper = styled.div`
  margin-top: 20px;

  & > div {
    margin: 15px 0 0;
  }

  ${Media.mobile`
    & > div {
      margin: 5px 0;
    }
  `}
`

const Size = styled.div`
  margin-bottom: 8px;
  line-height: 22px;
  color: ${Theme.colors.black_new};
  text-transform: uppercase;
  ${Mixin.font.GothamBook(14, 400)}
`
